module.exports = __webpack_public_path__ + "img/form_handle.5299d708.svg";